
export default {
  props: {
    classes: {
      type: String,
      default:
        "bg-blue-800 hover:bg-blue-700 rounded-full p-3 text-center text-gray-100",
    },
  },

  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },

    userPlanActive() {
      return this.$get(this.$$subscriptions, "status") === 'active';
    },

    freePackage() {
      return !this.customer || !this.userPlanActive;
    },

    freePackageUrl() {
      return this.customer ? "/invoice" : "/login";
    },
  },

  methods: {},
};
